﻿function init () {
  window.onload = function () {
    const preloader = document.querySelector('[data-preloader]')
    preloader.style.display = 'none'
    document.body.style.overflow = 'auto'
  }
}

export default init
